/* ============================================================
   Redi Food — PDP de almuerzos (EXP-04) · assets/pdp-redi.js
   Fuente: pdp-2026/prototype/pdp-redi.js (aprobado por Redi 2026-09-03).
   Vanilla, IIFE, sin build. Entrada: window.RF_PDP, que escribe
   sections/rf-pdp-almuerzo.liquid (product desde Liquid, sides desde el
   snippet rf-pdp-sides). Título, galería, migas y «otros almuerzos» los
   pinta Liquid (SSR): aquí solo viven el selector, la cantidad, el carrito
   y el cambio de miniatura.
   Emite CustomEvents flamel:pdp:* en `document` (misma convención que
   flamel:kit:* del armador) para el bridge de Analytics.
   ============================================================ */
(function () {
  'use strict';
  const D = window.RF_PDP || {};
  const UI_VERSION = D.uiVersion || '2026-09-v2';
  const root = document.querySelector('[data-rf-pdp]');
  if (!root || !D.sides || !D.product) return;
  const qs = new URLSearchParams(location.search);
  const product = D.product;

  /* ---------- estado ---------- */
  const state = { side1: null, side2: null, qty: 1, openSlot: null, pending: null, filter: { 1: D.defaultFilterBySlot?.[1] || 'todos', 2: D.defaultFilterBySlot?.[2] || 'todos' } };
  const sideById = (id) => D.sides.find((s) => s.id === id);
  // Formatea con el money_format de la tienda (shop.money_format) para cuadrar con el «| money» del SSR.
  // Sin decimales cuando el importe es entero (COP), como money_without_trailing_zeros.
  const fmt = (n) => {
    const tpl = D.moneyFormat || '${{amount_no_decimals}}';
    const int = Math.round(n), frac = Math.abs(n - int) > 0.005;
    const comma = /with_comma_separator/.test(tpl);
    const num = (frac ? n.toFixed(2) : String(int)).replace(/\B(?=(\d{3})+(?!\d))/g, comma ? '.' : ',');
    const val = comma ? num.replace(/\.(?=\d{2}$)/, ',') : num;
    // COP en es-CO: miles con punto → invertimos cuando la plantilla usa separador por defecto
    const es = comma ? val : val.replace(/,/g, '.');
    return tpl.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, es).replace(/<[^>]+>/g, '').trim();
  };
  const imgUrl = (u, w) => { if (!u) return ''; u = u.startsWith('//') ? 'https:' + u : u; return u + (u.includes('?') ? '&' : '?') + 'width=' + w; };
  const $ = (sel, el) => (el || root).querySelector(sel);
  const $$ = (sel, el) => [...(el || root).querySelectorAll(sel)];
  const fire = (name, detail) => document.dispatchEvent(new CustomEvent('flamel:pdp:' + name, { detail: Object.assign({ pdp_product: product.handle, pdp_ui_version: UI_VERSION }, detail || {}) }));

  /* ---------- galería (SSR): solo intercambio de miniatura ---------- */
  function bindThumbs() {
    const thumbs = $('[data-rf-thumbs]'); const main = $('[data-rf-gallery-main] img');
    if (!thumbs || !main) return;
    thumbs.addEventListener('click', (e) => {
      const b = e.target.closest('[data-thumb]'); if (!b) return;
      $$('.rf-gallery__thumb', thumbs).forEach((x) => x.classList.toggle('is-on', x === b));
      if (b.dataset.src) main.src = b.dataset.src;
      if (b.dataset.srcset) main.srcset = b.dataset.srcset;
    });
  }
  function renderPrice() { $$('[data-rf-price]').forEach((el) => { el.textContent = fmt(product.price / 100 * state.qty); }); }
  // Altura real del header de Dawn (sticky) para el scroll-margin y la galería pegajosa.
  function syncHeader() {
    const h = document.getElementById('shopify-section-header') || document.querySelector('.section-header');
    if (h) root.style.setProperty('--rf-header-h', h.offsetHeight + 'px');
  }

  /* ---------- slots ---------- */
  function renderSlots() {
    [1, 2].forEach((n) => {
      const el = $(`[data-rf-slot="${n}"]`);
      const s = sideById(state['side' + n]);
      el.classList.toggle('is-done', !!s);
      el.classList.toggle('is-on', state.openSlot === n);
      el.setAttribute('aria-expanded', state.openSlot === n ? 'true' : 'false');
      $('.rf-slot__img', el).innerHTML = s ? `<img src="${imgUrl(s.image, 120)}" alt="" width="40" height="40">` : (s === null ? n : '✓');
      $('.rf-slot__v', el).innerHTML = s ? `${s.short}<em>Cambiar</em>` : 'Elige uno';
    });
    const ready = state.side1 && state.side2;
    root.dataset.rfReady = ready ? '1' : '0';
  }

  /* ---------- panel / sheet ---------- */
  const panel = $('[data-rf-panel]');
  const backdrop = $('[data-rf-backdrop]');
  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;
  let lastFocus = null;

  const SOLD_OUT = product.available === false || root.dataset.rfSoldout === '1';

  function openSlot(n, method) {
    if (SOLD_OUT) return; // QA 2026-09-08: agotado = selector bloqueado entero; solo queda el «avísame»
    state.openSlot = n;
    state.pending = state['side' + n]; // la elección es provisional hasta «Confirmar»
    lastFocus = document.activeElement;
    panel.dataset.layout = qs.get('layout') || D.mobileLayout || 'grid'; // ?layout= solo para comparar variantes en QA
    setNote('');
    panel.hidden = false;
    panel.setAttribute('aria-label', 'Elige tu acompañamiento ' + n);
    $('[data-rf-panel-title]').textContent = 'Elige tu acompañamiento ' + n;
    if (isMobile()) { backdrop.hidden = false; document.body.style.overflow = 'hidden'; }
    renderChips(); renderCards(); renderSlots();
    fire('open', { pdp_slot: n, open_method: method || 'tap' });
    setTimeout(() => { const f = $('.rf-chip.is-on', panel) || $('.rf-panel__close', panel); f && f.focus({ preventScroll: true }); }, 30);
  }
  function closePanel() {
    if (state.openSlot === null) return;
    state.openSlot = null; state.pending = null; // cerrar sin confirmar descarta el cambio
    panel.hidden = true; backdrop.hidden = true; document.body.style.overflow = '';
    renderSlots();
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function visibleSides() {
    const f = state.filter[state.openSlot];
    return D.sides.filter((s) => f === 'todos' || s.filter === f);
  }
  function renderChips() {
    const n = state.openSlot; const cur = state.filter[n];
    $('[data-rf-chips]').innerHTML = D.filters.map((f) => {
      const count = f.id === 'todos' ? D.sides.length : D.sides.filter((s) => s.filter === f.id).length;
      return `<button type="button" class="rf-chip ${f.id === cur ? 'is-on' : ''}" data-chip="${f.id}" aria-pressed="${f.id === cur}">${f.label}<span class="rf-chip__n">${count}</span></button>`;
    }).join('');
  }
  function renderCards() {
    const n = state.openSlot; const chosen = state.pending;
    const list = visibleSides();
    const grid = $('[data-rf-opts]');
    grid.innerHTML = list.length ? list.map((s, i) => `
      <button type="button" class="rf-opt ${s.id === chosen ? 'is-on' : ''} ${s.soldOut ? 'is-soon' : ''}" data-side="${s.id}" data-pos="${i + 1}" ${s.soldOut ? 'aria-disabled="true"' : ''} aria-pressed="${s.id === chosen}">
        ${s.id === chosen ? '<span class="rf-opt__check" aria-hidden="true">✓</span>' : (s.soldOut ? '<span class="rf-opt__badge">Agotado</span>' : '')}
        <span class="rf-photo"><img src="${imgUrl(s.image, 320)}" alt="" loading="lazy" width="160" height="160"></span>
        <span class="rf-opt__name">${s.short}</span>
      </button>`).join('') : '<p class="rf-empty">No hay acompañamientos en este filtro.</p>';
    if (isMobile()) { grid.scrollLeft = 0; grid.scrollTop = 0; }
    renderConfirm();
  }
  function renderConfirm() {
    const b = $('[data-rf-confirm]'); const n = state.openSlot;
    b.textContent = 'Confirmar acompañamiento ' + n;
    b.classList.toggle('is-idle', !state.pending);
  }
  function setNote(msg) { const el = $('[data-rf-panel-note]'); el.textContent = msg; el.hidden = !msg; }

  // Tocar una card la marca; tocarla otra vez la desmarca (ronda 2). Nada cambia hasta «Confirmar».
  function pick(id, pos) {
    const n = state.openSlot; const s = sideById(id);
    if (!s || s.soldOut) return;
    state.pending = state.pending === id ? null : id;
    fire('tap', { pdp_slot: n, side_id: id, side_name: s.name, filter_id: state.filter[n], card_position: pos, deselect: state.pending === null });
    setNote('');
    renderCards();
  }
  function confirm() {
    const n = state.openSlot; const s = sideById(state.pending);
    if (!s) { setNote('Toca un plato para elegirlo.'); return; }
    const isChange = !!state['side' + n] && state['side' + n] !== s.id;
    state['side' + n] = s.id;
    $(`[data-rf-slot="${n}"]`).classList.remove('is-missing');
    fire('pick', { pdp_slot: n, side_id: s.id, side_name: s.name, filter_id: state.filter[n], is_change: isChange });
    setLive('');
    if (n === 1 && !state.side2) {
      // pasa al slot 2 avisando (ronda 2: «me cambió al acompañamiento 2 y ni cuenta me di»)
      openSlot(2, 'auto');
      setNote('Acompañamiento 1 listo: ' + s.short + '. Ahora elige el segundo.');
      return;
    }
    closePanel();
  }

  /* ---------- validación + carrito ---------- */
  const live = $('[data-rf-live]');
  function setLive(msg) { live.textContent = msg; }

  function buildCartPayload() {
    const s1 = sideById(state.side1), s2 = sideById(state.side2);
    const props = {};
    props[D.cartPropertyNames[0]] = s1.name;
    props[D.cartPropertyNames[1]] = s2.name;
    props._kit_components = [s1.variantId, s2.variantId].join(',');
    props._pdp_ui_version = UI_VERSION;
    return { items: [{ id: product.variantId, quantity: state.qty, properties: props }], sections: 'cart-icon-bubble' };
  }

  async function addToCart() {
    const missing = [1, 2].filter((n) => !state['side' + n]);
    if (missing.length) {
      const n = missing[0];
      setLive('Falta elegir tu acompañamiento ' + n);
      const el = $(`[data-rf-slot="${n}"]`); el.classList.remove('is-missing'); void el.offsetWidth; el.classList.add('is-missing');
      $('[data-rf-builder]').scrollIntoView({ behavior: 'smooth', block: 'start' });
      fire('blocked', { missing_slots: missing.join(',') });
      openSlot(n, 'cta_blocked');
      return;
    }
    const payload = buildCartPayload();
    const added = $('[data-rf-added]');
    const btns = $$('[data-rf-add]'); btns.forEach((b) => { b.disabled = true; b.dataset.label = b.textContent; b.textContent = 'Añadiendo…'; });
    try {
      const root_ = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const res = await fetch(root_ + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
      if (!res.ok) { const e = await res.json().catch(() => ({})); setLive(e.description || e.message || 'No se pudo añadir al carrito. Inténtalo de nuevo.'); fire('add_error', { status: res.status }); return; }
      const json = await res.json();
      refreshCartBubble(json.sections);
      fire('add', { value: (product.price / 100) * state.qty, quantity: state.qty, side_ids: [state.side1, state.side2].join(','), variant_id: product.variantId });
      showAdded();
    } catch (e) { setLive('Sin conexión. Revisa tu red e inténtalo de nuevo.'); fire('add_error', { status: 'network' }); }
    finally { btns.forEach((b) => { b.disabled = false; b.textContent = b.dataset.label || 'Añadir al carrito'; }); }
    function showAdded() { $('[data-rf-added-title]').textContent = 'Listo, tu ' + product.title + ' está en el carrito'; added.hidden = false; added.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
  }

  /* Repinta el contador del header sin recargar (patrón arma-tu-kit.js): la section
     `cart-icon-bubble` renderiza justo el interior del <a id="cart-icon-bubble">. */
  function refreshCartBubble(sections) {
    try {
      const html = sections && sections['cart-icon-bubble'];
      const host = document.getElementById('cart-icon-bubble');
      if (!html || !host) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.getElementById('shopify-section-cart-icon-bubble') || doc.querySelector('.shopify-section');
      if (fresh) host.innerHTML = fresh.innerHTML;
    } catch (e) { /* el contador se pone al día en la siguiente navegación */ }
  }

  /* ---------- eventos ---------- */
  // Vídeo y ancla viven en otras secciones (fuera del root): delegación en document.
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-rf-goto-builder]')) { e.preventDefault(); $('[data-rf-builder]').scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
    if (e.target.closest('[data-rf-goto-others]')) { e.preventDefault(); const o = document.getElementById('rf-otros'); if (o) o.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
    if (e.target.closest('[data-rf-goto-restock]')) { e.preventDefault(); const r = $('[data-rf-restock]'); if (r) { r.scrollIntoView({ behavior: 'smooth', block: 'center' }); const i = r.querySelector('input[type=email]'); i && i.focus({ preventScroll: true }); } return; }
    const video = e.target.closest('[data-rf-video]');
    if (video && !video.dataset.loaded) { video.dataset.loaded = '1'; video.innerHTML = `<iframe src="https://www.youtube.com/embed/${video.dataset.rfVideo}?autoplay=1&rel=0" title="Cómo calentar tu almuerzo Redi" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>`; fire('video_play', {}); }
  });
  root.addEventListener('click', (e) => {
    const slot = e.target.closest('[data-rf-slot]');
    if (slot) { const n = +slot.dataset.rfSlot; state.openSlot === n ? closePanel() : openSlot(n, 'tap'); return; }
    const chip = e.target.closest('[data-chip]');
    if (chip) { state.filter[state.openSlot] = chip.dataset.chip; fire('filter', { filter_id: chip.dataset.chip, pdp_slot: state.openSlot, filter_default: 0 }); renderChips(); renderCards(); return; }
    const opt = e.target.closest('[data-side]');
    if (opt) { pick(opt.dataset.side, +opt.dataset.pos); return; }
    if (e.target.closest('[data-rf-confirm]')) { confirm(); return; }
    if (e.target.closest('[data-rf-close]')) { closePanel(); return; }
    const q = e.target.closest('[data-rf-qty]');
    if (q) { state.qty = Math.max(1, Math.min(20, state.qty + (+q.dataset.rfQty))); $$('[data-rf-qty-n]').forEach((el) => (el.textContent = state.qty)); renderPrice(); return; }
    if (e.target.closest('[data-rf-add]')) { addToCart(); return; }
    if (e.target.closest('[data-rf-again]')) { $('[data-rf-added]').hidden = true; $('[data-rf-builder]').scrollIntoView({ behavior: 'smooth' }); return; }
  });
  backdrop.addEventListener('click', closePanel);
  document.addEventListener('keydown', (e) => {
    if (state.openSlot === null) return;
    if (e.key === 'Escape') { closePanel(); return; }
    if (e.key === 'Tab') { // foco atrapado dentro del sheet en móvil
      if (!isMobile()) return;
      const f = $$('button, [href], input', panel).filter((x) => !x.hidden && x.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  window.addEventListener('resize', () => { syncHeader(); if (state.openSlot !== null) { backdrop.hidden = !isMobile(); document.body.style.overflow = isMobile() ? 'hidden' : ''; } });

  /* Fakedoor de reposición: el form 'customer' de Shopify hace el POST (sin Klaviyo). Aquí solo se mide
     la intención para saber si merece la pena montar el flujo de restock. */
  /* Solo confirmamos después de que Shopify confirme el alta: markup de
     posted_successfully? o customer_posted=true en el retorno. Haber enviado el
     formulario no prueba éxito: hCaptcha, validación o navegación pueden impedirlo. */
  const restockForm = $('#rf-restock-form');
  if (restockForm) restockForm.addEventListener('submit', () => {
    fire('restock_submit', {});
  });
  function restockConfirmed() {
    if ($('[data-rf-restock-ok]')) return 'server';
    if (/[?&]customer_posted=true(?:[&#]|$)/.test(location.href)) return 'param';
    return '';
  }
  const restockBox = $('[data-rf-restock]');
  const how = restockBox ? restockConfirmed() : '';
  if (how) {
    if (!$('[data-rf-restock-ok]') && restockForm) {
      const okMsg = restockBox.dataset.rfOk || 'Listo, guardamos tu correo. Te escribimos cuando vuelva a estar disponible.';
      const othersLbl = restockBox.dataset.rfOthers || 'Mientras tanto, mira otros almuerzos disponibles';
      const done = document.createElement('div'); done.className = 'rf-restock__done'; done.setAttribute('data-rf-restock-ok', ''); done.setAttribute('role', 'status');
      done.innerHTML = '<p class="rf-restock__ok">✓ ' + okMsg + '</p><a class="rf-btn rf-btn--green rf-btn--md" href="#rf-otros" data-rf-goto-others>' + othersLbl + '</a>';
      restockForm.replaceWith(done);
    }
    const box = $('[data-rf-restock]'); if (box) box.scrollIntoView({ block: 'center' });
    fire('restock_ok', { restock_confirmed_by: how });
    setTimeout(() => { const o = document.getElementById('rf-otros'); if (o) o.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 2500);
  }

  /* ---------- arranque ---------- */
  syncHeader(); bindThumbs(); renderPrice(); renderSlots();
  fire('view', { pdp_variant: 'v2', pdp_price: product.price / 100, pdp_available: SOLD_OUT ? 0 : 1 });
  window.RF_PDP_API = { state, buildCartPayload, openSlot, closePanel, pick, confirm, product }; // para QA
})();
